import calendarEn from "./calendarEn";
import commonEn from "./commonEn";
import eventsEn from "./eventsEn";
import authEn from "./authEn";
import filtersEn from "./filtersEn";
import knowledgebaseEn from "./knowledgebaseEn";
import settingsEn from "./settingsEn";
import reservationEn from "./reservationEn";
import validationEn from "./validationEn";
import errorsEn from "./errorsEn";
import statisticsEn from "./statisticsEn";

const mainEn = {
    common: commonEn,
    calendar: calendarEn,
    events: eventsEn,
    auth: authEn,
    filters: filtersEn,
    knowledgebase: knowledgebaseEn,
    settings: settingsEn,
    reservation: reservationEn,
    validation: validationEn,
    error: errorsEn,
    statistics: statisticsEn,
}

export default mainEn;